/* eslint-disable react/no-this-in-sfc */
/* eslint-disable func-names */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Box } from '@chakra-ui/react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import _ from 'lodash';
import { useFormValidationToast } from '../../../services/actionToast';
import { InputForm } from '../../inputs/forms/InputForm';
import { getFetchData, useFetch } from '../../../hooks/useFetch';
import { SelectInputForm } from '../../inputs/forms/SelectInputForm';
import { MaskedInputForm } from '../../inputs/forms/MaskedInputForm';
import { CepField } from '../../inputs/forms/CepField';
import { SwitchInputForm } from '../../inputs/forms/SwitchInputForm';
import { FormActions, FormRow, FormSection, FormShell } from '../../ui';
import { getFormattedLabel } from '../../../utils/FormatFunctions';

interface InstitutionFormProps {
  defaultValues?: any;
}

interface FormInputsProps {
  name: string;
  value: any;
  placeholder?: string;
  label: string;
  yup: any;
}

export default function UserInstitutionForm({ defaultValues }: InstitutionFormProps) {
  const validationToast = useFormValidationToast();
  const baseUrl = '/v1/admin/institutions';
  const { requestApi: reqApiInstitutions } = useFetch(baseUrl);
  const {
    requestApi: reqApiSecretaries,
    data: dataSecretaries,
    loading: loadingSecretaries,
  } = useFetch('/v1/admin/secretaries');
  const { data: optionsSecretaries, pagination: paginationSecretaries } =
    getFetchData(dataSecretaries);
  const { requestApi: reqApiCodepost, error: errorCodepost } = useFetch('/v1/client/address');
  const [loadingCodepost, setLoadingCodepost] = useState<any>(false);
  const [address, setAddress] = useState<any>({});
  const [isFirstRender, setIsFirstRender] = useState(true);

  const optionsType = [
    {
      label: 'Pública',
      value: 'PUBLICA',
    },
    {
      label: 'Privada',
      value: 'PRIVADA',
    },
  ];

  const yupschema: any = {};
  const defaultValuesSchema: any = {};

  const formInputs: FormInputsProps[] = [
    {
      name: 'name',
      value: defaultValues?.name ?? '',
      placeholder: 'Nome da escola',
      label: 'Nome da escola',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'secretary_id',
      value: defaultValues?.secretary ? getFormattedLabel(defaultValues?.secretary) : null,
      placeholder: 'Selecione uma secretaria',
      label: 'Secretaria',
      yup: Yup.mixed().test('is-public', 'Este campo é obrigatório!', function (value: any) {
        if (this.parent.type === 'PUBLICA' || this.parent.type?.value === 'PUBLICA') return value;
        return true;
      }),
    },
    {
      name: 'site',
      value: defaultValues?.site ?? '',
      placeholder: 'Site da instituição',
      label: 'Site',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'type',
      value: defaultValues?.type
        ? optionsType.find((item) => item.value === defaultValues?.type)
        : null,
      placeholder: 'Tipo de instituição',
      label: 'Tipo',
      yup: Yup.mixed().required('Este campo é obrigatório!'),
    },
    {
      name: 'cell_phone',
      value: defaultValues?.cell_phone ?? '',
      placeholder: 'Telefone da instituição',
      label: 'Telefone',
      yup: Yup.string(),
    },
    {
      name: 'code_post',
      value: defaultValues?.address?.code_post ?? '',
      placeholder: 'CEP da instituição',
      label: 'CEP',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'city_id',
      value: defaultValues?.address?.city?.id ?? '',
      placeholder: '',
      label: 'Cidade',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'city_name',
      value: defaultValues?.address?.city?.name ?? '',
      placeholder: 'Cidade da instituição',
      label: 'Cidade',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'state_name',
      value: defaultValues?.address?.city?.state?.name ?? '',
      placeholder: 'Estado da instituição',
      label: 'Estado',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'street',
      value: defaultValues?.address?.street ?? '',
      placeholder: 'Rua da instituição',
      label: 'Rua',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'number',
      value: defaultValues?.address?.number ?? '',
      placeholder: 'Número da instituição',
      label: 'Número',
      yup: Yup.string(),
    },
    {
      name: 'district',
      value: defaultValues?.address?.district ?? '',
      placeholder: 'Bairro da instituição',
      label: 'Bairro',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'complement',
      value: defaultValues?.address?.complement ?? '',
      placeholder: 'Complemento da instituição',
      label: 'Complemento',
      yup: Yup.string(),
    },
    {
      name: 'responsible',
      value: defaultValues?.responsible ?? '',
      placeholder: 'Nome do responsável',
      label: 'Nome',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'email',
      value: defaultValues?.email ?? '',
      placeholder: 'Email do responsável',
      label: 'Email',
      yup: Yup.string().email('Email inválido').required('Este campo é obrigatório!'),
    },
    {
      name: 'responsible_phone',
      value: defaultValues?.responsible_phone ?? '',
      placeholder: 'Telefone do responsável',
      label: 'Telefone',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'function',
      value: defaultValues?.function ?? '',
      placeholder: 'Função do responsável',
      label: 'Função',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'status',
      value: defaultValues?.status ?? true,
      label: 'Status',
      yup: Yup.boolean(),
    },
  ];

  formInputs.forEach((object) => {
    yupschema[object.name] = object.yup;
    defaultValuesSchema[object.name] = object.value;
  });
  const schema = Yup.object().shape(yupschema);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValuesSchema,
  });

  const name = formInputs.find((field) => field.name === 'name');
  const secretary = formInputs.find((field) => field.name === 'secretary_id');
  const cellphone = formInputs.find((field) => field.name === 'cell_phone');
  const site = formInputs.find((field) => field.name === 'site');
  const type = formInputs.find((field) => field.name === 'type');
  const codePost = formInputs.find((field) => field.name === 'code_post');
  const city = formInputs.find((field) => field.name === 'city_name');
  const state = formInputs.find((field) => field.name === 'state_name');
  const street = formInputs.find((field) => field.name === 'street');
  const number = formInputs.find((field) => field.name === 'number');
  const district = formInputs.find((field) => field.name === 'district');
  const complement = formInputs.find((field) => field.name === 'complement');
  const responsible = formInputs.find((field) => field.name === 'responsible');
  const responsibleEmail = formInputs.find((field) => field.name === 'email');
  const responsiblePhone = formInputs.find((field) => field.name === 'responsible_phone');
  const responsibleFunction = formInputs.find((field) => field.name === 'function');
  const status = formInputs.find((field) => field.name === 'status');

  const onSubmit = async (values: any) => {
    const params = {
      ...values,
      type: values.type.value,
      secretary_id: values.secretary_id?.value ?? null,
      address: {
        code_post: values.code_post,
        city_id: Number(values.city_id),
        street: values.street,
        number: values.number,
        district: values.district,
        complement: values.complement,
      },
      code_post: _,
      city_id: _,
      city_name: _,
      state_name: _,
      street: _,
      number: _,
      district: _,
      complement: _,
    };
    await reqApiInstitutions(
      defaultValues?.name ? 'put' : 'post',
      params,
      defaultValues?.name ? `${baseUrl}/${defaultValues?.id}` : null
    );
  };

  const getCep = async (cep) => {
    const { data, status: statusRes } = await reqApiCodepost('get', { params: { code_post: cep } });
    if (statusRes === 200) {
      setAddress(data?.data);
    } else {
      setAddress({});
    }
    setLoadingCodepost(false);
  };

  useEffect(() => {
    if (defaultValues?.name) {
      reset(defaultValuesSchema);
      getCep(watch('code_post').replace(/\D/g, ''));
    }
  }, [defaultValues]);

  useEffect(() => {
    setValue('city_id', address?.city?.id);
    setValue('city_name', address?.city?.name);
    setValue('state_name', address?.city?.state?.name);
    setValue('street', address?.street);
    setValue('district', address?.district);
  }, [address]);

  useEffect(() => {
    if (watch('code_post').replace(/\D/g, '').length < 8) {
      setAddress(null);
      return;
    }
    if (!isFirstRender) {
      setLoadingCodepost(true);
      const timeout = setTimeout(() => {
        getCep(watch('code_post').replace(/\D/g, ''));
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [watch('code_post')]);

  useEffect(() => {
    setIsFirstRender(false);
  }, []);

  return (
    <FormShell title="Minha Instituição" backTo="/institutions/list" backLabel="Instituições">
      <Box
        as="form"
        noValidate
        onSubmit={handleSubmit(onSubmit, validationToast)}
        display="flex"
        flexDirection="column"
        gap="16px"
      >
        <FormSection title="Informações Básicas">
          <FormRow>
            <InputForm
              name={name?.name}
              label={name?.label}
              placeholder={name?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
            <SelectInputForm
              name={type?.name}
              label={type?.label}
              options={optionsType}
              placeholder={type?.placeholder}
              isRequired
              control={control}
              errors={errors}
            />
          </FormRow>

          <FormRow>
            <SelectInputForm
              name={secretary?.name}
              label={secretary?.label}
              options={[...(optionsSecretaries?.map((item) => getFormattedLabel(item)) ?? [])]}
              isLoading={loadingSecretaries}
              pagination={paginationSecretaries}
              getOptions={(filters) => reqApiSecretaries('get', { params: { ...filters } })}
              placeholder={secretary?.placeholder}
              control={control}
              errors={errors}
            />
            <MaskedInputForm
              name={cellphone?.name}
              label={cellphone?.label}
              placeholder={cellphone?.placeholder}
              control={control}
              errors={errors}
              mask="(99) 99999-9999"
            />
            <InputForm
              name={site?.name}
              label={site?.label}
              placeholder={site?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
            <SwitchInputForm
              name={status?.name}
              label={status?.label}
              errors={errors}
              control={control}
            />
          </FormRow>
        </FormSection>

        <FormSection title="Endereço">
          <FormRow>
            <CepField
              name={codePost?.name}
              label={codePost?.label}
              placeholder={codePost?.placeholder}
              control={control}
              errors={errors}
              isLoading={loadingCodepost}
              notFoundMessage={errorCodepost?.status === 404 ? errorCodepost?.msg : undefined}
            />
            <InputForm
              name={city?.name}
              label={city?.label}
              placeholder={city?.placeholder}
              isDisabled
              isRequired
              register={register}
              errors={errors}
            />
            <InputForm
              name={state?.name}
              label={state?.label}
              placeholder={state?.placeholder}
              isDisabled
              isRequired
              register={register}
              errors={errors}
            />
          </FormRow>

          <FormRow>
            <InputForm
              name={street?.name}
              label={street?.label}
              placeholder={street?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
            <InputForm
              name={number?.name}
              label={number?.label}
              placeholder={number?.placeholder}
              type="number"
              register={register}
              errors={errors}
            />
            <InputForm
              name={district?.name}
              label={district?.label}
              placeholder={district?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
            <InputForm
              name={complement?.name}
              label={complement?.label}
              placeholder={complement?.placeholder}
              register={register}
              errors={errors}
            />
          </FormRow>
        </FormSection>

        <FormSection title="Responsável">
          <FormRow>
            <InputForm
              name={responsible?.name}
              label={responsible?.label}
              placeholder={responsible?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
            <InputForm
              name={responsibleEmail?.name}
              label={responsibleEmail?.label}
              placeholder={responsibleEmail?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
            <MaskedInputForm
              name={responsiblePhone?.name}
              label={responsiblePhone?.label}
              placeholder={responsiblePhone?.placeholder}
              isRequired
              control={control}
              errors={errors}
              mask="(99) 99999-9999"
            />
            <InputForm
              name={responsibleFunction?.name}
              label={responsibleFunction?.label}
              placeholder={responsibleFunction?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
          </FormRow>
        </FormSection>

        <FormActions cancelTo="/institutions/list" isLoading={isSubmitting} />
      </Box>
    </FormShell>
  );
}
